import React from "react";
import { Button } from "./Button";
import { FiAlertCircle } from "react-icons/fi";
import { ImCross } from "react-icons/im";
import { useIsMobile } from "../../hooks/useIsMobile";

interface UploadNavigationWarningProps {
    isOpen: boolean;
    onClose: () => void;
    onLeave: () => void;
    onStay: () => void;
}

export default function UploadNavigationWarning({
    isOpen = false,
    onClose,
    onLeave,
    onStay,
}: UploadNavigationWarningProps) {
    const isMobile = useIsMobile(900);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 p-4 z-50">
            <div
                className={`relative ${
                    isMobile ? "w-full max-w-md" : "w-1/3"
                } rounded-lg bg-white p-6 shadow-lg z-50`}
            >
                <button
                    onClick={onClose}
                    className="absolute right-4 top-4 text-gray-500 hover:text-gray-700 focus:outline-none"
                    aria-label="Close"
                >
                    <ImCross className="h-6 w-6" />
                </button>
                <div className="flex flex-col items-center text-center">
                    <FiAlertCircle className="h-16 w-16 text-yellow-500" />
                    <h2 className="mt-4 text-xl sm:text-2xl font-bold text-primary">
                        Uploads in progress
                    </h2>
                    <p className="mt-2 text-gray-600 text-sm sm:text-base">
                        You have uploads still running.
                    </p>
                    <p className="mt-1 text-gray-600 text-sm sm:text-base">
                        Leaving this page will cancel any remaining uploads that
                        haven&apos;t finished.
                    </p>
                    <p className="mt-1 text-gray-600 text-sm sm:text-base">
                        If you want everything to upload, stay on this page
                        until the upload completes.
                    </p>

                    <div
                        className={`mt-6 w-full ${
                            isMobile ? "flex flex-col space-y-2" : "flex justify-between space-x-4"
                        }`}
                    >

                        <Button
                            onClick={onLeave}
                            className="w-full sm:w-auto"
                            variant="destructive"
                        >
                            Leave page
                        </Button>                       
                        <Button
                            onClick={onStay}
                            variant="secondary"
                            className="w-full sm:w-auto"
                        >
                            Stay on page
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
